let gadsInitialized = false;
const gadsId = process.env.REACT_APP_GADS_ID;

export const initGoogleAdsense = () => {
  if (typeof window === "undefined" || gadsInitialized) {
    return;
  }

  if (!gadsId) {
    console.warn("Google Ads ID not found. Adsense conversion tracking will be disabled.");
    return;
  }

  try {
    // Load the gtag.js script for Google Ads (shares gtag global with GA)
    // Only load if gtag isn't already present (GA may have loaded it)
    if (!window.gtag) {
      const script = document.createElement("script");
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${gadsId}`;
      document.head.appendChild(script);

      window.dataLayer = window.dataLayer || [];
      window.gtag = function () {
        window.dataLayer.push(arguments);
      };
      window.gtag("js", new Date());
    }

    window.gtag("config", gadsId);
    gadsInitialized = true;
  } catch (error) {
    console.error("Google Adsense initialization failed:", error);
  }
};

export const trackGAdsConversion = (conversionLabel, properties = {}) => {
  if (!gadsInitialized || !window.gtag || !gadsId) {
    return;
  }

  try {
    window.gtag("event", "conversion", {
      send_to: `${gadsId}/${conversionLabel}`,
      ...properties,
    });
  } catch (error) {
    console.error("Unable to track Google Ads conversion:", { conversionLabel, properties, error });
  }
};
